// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './SplitButton';



// WEBPACK FOOTER //
// ./components/SplitButton/index.js